// extracted by mini-css-extract-plugin
export var socialSharing = "SocialSharing-module--social-sharing--II6np";
export var facebook = "SocialSharing-module--facebook--2EJQB";
export var linkedIn = "SocialSharing-module--linked-in--3E2xN";
export var twitter = "SocialSharing-module--twitter--5OWfr";